import { Icon, IconName, Text } from '@usealloy/component-library';
import { StyledToolbarContainer, StyledToolbarMessage } from '../styles';
import { useContext } from 'react';
import { RuleBuilderContext } from '../../context';
import { ContainerType } from '../../../types';

const InfoToolbar = () => {
  const { containerType } = useContext(RuleBuilderContext);

  return (
    <StyledToolbarContainer inIsland={containerType === ContainerType.ISLAND}>
      <StyledToolbarMessage>
        <Icon icon={IconName.LightbulbHint} color="var(--cl-gray-1100)" />
        <Text size={2} weight={400}>
          This node was a duplicate and logic has been merged.
        </Text>
      </StyledToolbarMessage>
    </StyledToolbarContainer>
  );
};

export default InfoToolbar;
